<template>
  <form class="register-form">
    <v-text-field
      v-model="state.email"
      label="Email"
      required
      type="email"
      variant="outlined"
      prepend-inner-icon="mdi-email"
      density="comfortable"
      class="mb-3"
    ></v-text-field>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="state.firstName"
          label="First Name"
          required
          variant="outlined"
          prepend-inner-icon="mdi-account"
          density="comfortable"
          class="mb-3"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="state.lastName"
          label="Last Name"
          required
          variant="outlined"
          prepend-inner-icon="mdi-account"
          density="comfortable"
          class="mb-3"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-text-field
      v-model="state.password"
      label="Password"
      required
      type="password"
      variant="outlined"
      prepend-inner-icon="mdi-lock"
      :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      density="comfortable"
      class="mb-4"
      @click:append-inner="showPassword = !showPassword"
    ></v-text-field>

    <v-btn
      block
      size="large"
      color="primary"
      variant="elevated"
      @click="onClickRegister"
      :loading="state.loading"
      class="mb-4"
    >
      Create Account
    </v-btn>

    <v-divider class="my-4"></v-divider>

    <div class="text-center">
      <span class="text-body-2">Already have an account?</span>
      <RouterLink :to="URLs.PAGE_AUTH_LOGIN" class="text-decoration-none text-primary ml-2">
        Sign In
      </RouterLink>
    </div>
  </form>
</template>

<script setup lang="ts">
import { URLs } from "@/constants";
import { useAuthStore } from "@/stores/auth";
import { makeAlert } from "@/utils";
import { ref } from "vue";
import { useRouter } from "vue-router";

const authStore = useAuthStore();
const router = useRouter();

const state = ref({
  email: "",
  password: "",
  firstName: "",
  lastName: "",
  loading: false
});

const showPassword = ref(false);

const onClickRegister = async () => {
  state.value.loading = true;
  const response = await authStore.register({
    email: state.value.email,
    password: state.value.password,
    name: `${state.value.firstName} ${state.value.lastName}`
  });
  state.value.loading = false;

  if (response.status) {
    makeAlert("Register success", "success");
    router.push({
      path: URLs.PAGE_AUTH_CONFIRM_REGISTER,
      query: {
        email: state.value.email
      }
    });
  } else {
    makeAlert(response.message, "error");
  }
};
</script>
